<template>
  <el-dialog
    title="分享模板"
    width="1100px"
    v-drag
    v-loading="loading"
    class="kye-dialog__modal-in-tab"
    :modal-append-to-body="false"
    :close-on-press-escape="escape"
    :close-on-click-modal="false"
    :visible.sync="show"
    custom-class="kye-custom-filter-share"
    @close="onClose"
    @open="onOpen">
    <template>
      <div class="tpl-wrap">
        <el-autocomplete
          ref="templateFilter"
          v-model="templateKey"
          clearable
          placeholder="搜索模板名"
          class="tpl-popper"
          popper-class="kye-popper-auto"
          value-key="name"
          :trigger-on-focus="false"
          :fetch-suggestions="filterTemplate"
          @select="selectTemplate">
          <i slot="prefix" class="layout layout-search"></i>
        </el-autocomplete>
        <el-scrollbar>
          <el-tree
            v-if="showTree"
            :data="templates"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="shareTree"
            highlight-current
            :props="elTreeProps"
            @check-change="onTemplateChange">
            <div slot-scope="{ data }" class="tpl-list">
              <span class="tpl-name">{{data.name}}</span>
              <i class="tpl-edit el-icon-edit"
                 @click.stop.prevent="showNameDialog(data)">
              </i>
            </div>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="user-wrap">
        <el-form class="kye-query-form" :inline="true" :model="form">
          <el-form-item label="姓名/工号">
            <el-autocomplete
              ref="userFilter"
              v-model="form.user"
              placeholder=""
              clearable
              style="width:110px;"
              :fetch-suggestions="fetchUser"
              @select="selectUser">
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="组织">
            <el-input
              readonly
              style="width:110px;"
              :value="showDeptLabel"
              @click.native="openDeptTree"
              @focus="deptFocus = true"
              @blur="deptFocus = false"
              @mouseenter.native="deptFocus = true"
              @mouseleave.native="deptFocus = false">
              <i
                slot="suffix"
                v-show="deptFocus && showDeptLabel"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click.stop="clearDept">
              </i>
            </el-input>
          </el-form-item>
          <el-form-item label="岗位">
            <el-select
              v-model="form.duty"
              class="kye-select--multiple"
              clearable
              remote
              filterable
              multiple
              reserve-keyword
              collapse-tags
              placeholder=""
              :loading="dutyLoading"
              :remote-method="fetchDuty"
              @visible-change="e => selectVisibleChange(e)">
              <el-option
                v-for="item in duties"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工种">
            <el-select
              v-model="form.jobs"
              class="kye-select--multiple"
              clearable
              remote
              filterable
              multiple
              reserve-keyword
              collapse-tags
              placeholder=""
              :loading="JobLoading"
              :remote-method="fetchJob"
              @visible-change="e => jobSelectVisibleChange(e)">
              <el-option
                v-for="item in jobs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button
            type="text"
            icon="layout layout-plus"
            @click="addRows">添加
          </el-button>
          <el-button
            type="text"
            icon="layout layout-delete"
            style="margin-left:8px;"
            @click="deleteRows">删除
          </el-button>
        </el-form>
        <kye-button type="text" @click="handleImport" icon="layout layout-import" style="margin-bottom: 4px;">导入</kye-button>
        <el-table
          ref="table"
          border
          :data="rows"
          :max-height="tableHeight"
          @selection-change="selectionChange">
          <el-table-column type="index" width="45"></el-table-column>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column
            prop="employeeNumber"
            label="工号"
            width="60"
            sortable
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="chineseName"
            label="姓名"
            width="100"
            sortable
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="duty"
            label="岗位"
            width="160"
            sortable
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="jobType"
            label="工种"
            width="100"
            sortable
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="departmentName"
            label="部门"
            sortable
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template slot="footer">
      <span style="padding-right:16px;">已选中：{{selectedRows.length}}</span>
      <kye-button
        type="primary"
        auth="BTonkLNcnhiZ"
        @click="submit">分享
      </kye-button>
      <kye-button @click="show = false">取消</kye-button>
    </template>
    <dept-dialog ref="deptDialog" :model="form" @change="changeDept" :preloadDeptTree="false" />
    <name-dialog
      ref="nameDialog"
      :escape="escape"
      :model="formName"
      @change="saveTemplateName" />

      <kye-data-import
        :code="importConfig.code"
        :url="importConfig.url"
        :params="importConfig.params"
        :isAsync="importConfig.isAsync"
        :visible.sync="importConfig.show"
        :appkey="importConfig.appkey"
        @change="importChange"
        @success="val => importSuccess(val)">
    </kye-data-import>
  </el-dialog>
</template>

<script>
  import DeptDialog from './dept-dialog'
  import NameDialog from './template-name-dialog'

  const EMPTY_LIST = []

  export default {
    name: 'template-share-dialog',
    components: { DeptDialog, NameDialog },
    props: {
      escape: Boolean,
      templates: Array,
      shareRequestUrl: {
        type: String,
        default: 'system.genericSearchTemplate.shareTo' // 通用查询模版使用的分享保存接口
      },
      updateTemplateNameUrl: {
        type: String,
        default: 'system.genericSearch.template.saveOrUpdate' // 通用查询模版使用的更新模版名称接口
      },
      businessType: {
        type: String,
        default: '0' // 默认通用查询
      }
    },
    data () {
      return {
        importConfig: {
          appkey: '10124',
          model: {},
          importId: null,
          code: 'generic_search_template_share_template',
          url: 'system.genericSearch.template.importShareExcel',
          isAsync: true,
          show: false,
          params: {}
        },
        show: false,
        loading: false,
        dutyLoading: false,
        JobLoading: false,
        deptFocus: false,
        dept: {
          propertyName: 'dept',
          queryValue2: null,
          _queryValue: null
        },
        formName: { templateName: '' },
        form: {
          user: '',
          dept: '',
          jobs: [],
          duty: [],
          isLeaf: true
        },
        elTreeProps: {
          children: 'templateList',
          label: 'name'
        },
        duties: [],
        jobs: [],
        rows: [],
        templateIds: [],
        selectedRows: [],
        templateKey: '',
        tableHeight: Math.floor(window.innerHeight * 0.7 - 112),
        allSearchResult: {},
        jobAllSearchResult: {},
        showTree: false
      }
    },
    computed: {
      showDeptLabel () {
        let arr = this.dept._queryValue
        if (arr && arr.length) {
          return arr.map(v => v.label).join()
        }
        return ''
      }
    },
    methods: {
      onOpen () {
        this.showTree = true
        this.$bus.$emit('preload-dept-tree')
      },
      onClose () {
        this.showTree = false
        this.$emit('close')
      },
      async submit () {
        if (!this.templateIds.length || !this.selectedRows.length) {
          this.$message.warning('请勾选模板和分享人')
          return
        }
        let hasSelf = this.$store.state.user.id
        hasSelf = hasSelf && this.selectedRows.find(v => v.id === hasSelf)
        if (hasSelf) {
          this.$message.warning('分享人不能选中自己')
          return
        }
        const userIds = this.selectedRows.map(v => v.id)
        // 兼容个性化配置的一个模版传入两个模块id
        const ids = this.templateIds.reduce((prev, cur) => prev.concat(cur.split(',')), [])
        const data = { ids, userIds }
        this.loading = true
        try {
          await this.$http(this.shareRequestUrl, data)
          this.$message.success('分享成功')
          this.templateIds = []
          this.$refs.shareTree.setCheckedKeys([])
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      },
      openDeptTree () {
        this.$refs.deptDialog.open(this.dept)
      },
      clearDept () {
        this.dept._queryValue = null
        this.form.dept = ''
      },
      fetchUser (val, cb) {
        if (!val || val.length < 2) {
          this.cacheData = null
          cb(EMPTY_LIST)
          return
        }
        if (val && /\s+/.test(val)) {
          let value = val.replace(/\s+/, ' ')
          let arr = value.split(' ')
          if (!arr[0] || arr[0].length < this.inputLength) {
            this.$refs['userFilter'].loading = false
            return
          }
          if (arr[1] && this.cacheData && this.cacheData.length > 0) {
            let data = this.cacheData.filter(item => {
              return ['chineseName', 'position', 'departmentName', 'employeeNumber'].some(k => item[k].includes(arr[1]))
            })
            cb(data)
            this.$nextTick(_ => {
              this.$refs['userFilter'].highlight && this.$refs['userFilter'].highlight(0)
            })
          } else if (!arr[1] && this.cacheData && this.cacheData.length > 0) {
            cb(this.cacheData)
            this.$nextTick(_ => {
              this.$refs['userFilter'].highlight && this.$refs['userFilter'].highlight(0)
            })
          }
        } else {
          let data = null
          if (/^\d{6,}$/.test(val)) {
            data = { employeeNumber: val, status: '10' }
          } else if (!/^\d+$/.test(val)) {
            data = { chineseName: val, status: '10' }
          }
          if (!data) {
            this.cacheData = null
            cb(EMPTY_LIST)
            return
          }
          this.$http('data.employee.listByName', data)
            .then(res => {
              if (res && res.length) {
                // res = res.slice(0, 10)
                res.forEach(v => {
                  v.duty = v.position
                  v.value = `${v.chineseName}，${v.position || ''}，${v.departmentName}，${v.employeeNumber}`
                })
                this.cacheData = res
                cb(res)
                // 自动选择第一行
                this.$nextTick(_ => {
                  this.$refs['userFilter'].highlight && this.$refs['userFilter'].highlight(0)
                })
              } else {
                this.cacheData = null
                cb(EMPTY_LIST)
              }
            })
        }
      },
      selectUser (val) {
        if (val && val.id && this.$store.state.user.id === val.id) {
          this.$message.warning('分享人不能选中自己！')
          this.form.user = ''
          return
        }
        if (val && !this.rows.find(v => v.id === val.id)) {
          this.form.user = ''
          this.rows.unshift(val)
          this.scrollTop()
          this.selectAppendRows([val])
          this.$message.success('添加1条')
        }
      },
      selectVisibleChange (val) {
        if (val) {
          this.duties = Object.keys(this.allSearchResult).reduce((prev, key) => {
            if (this.form.duty.includes(key)) {
              const cur = this.allSearchResult[key]
              prev.push(cur)
            }
            return prev
          }, [])
        }
      },
      fetchDuty (val) {
        if (!val || val.length < 2) {
          return
        }
        this.dutyLoading = true
        this.$http('hr.duty.getDutyByConditionNew', { name: val })
          .then(res => {
            this.dutyLoading = false
            if (res && res.length) {
              this.duties = res.map(v => ({ label: v.name, value: v.id }))
              this.allSearchResult = res.reduce((prev, cur) => {
                prev[cur.id] = { label: cur.name, value: cur.id }
                return prev
              }, this.allSearchResult)
            }
          })
          .catch(_ => {
            this.dutyLoading = false
          })
      },
      jobSelectVisibleChange (val) {
        if (val) {
          this.jobs = this.form.jobs.map(value => ({ label: value, value: value }))
        }
      },
      fetchJob (val) {
        if (!val || val.length < 2) {
          return
        }
        this.JobLoading = true
        // isFuzzy 0 模糊  1 精准
        // qryType 1-工种 2-职级 3-岗位属性 4-岗位职能 6-岗位序列
        this.$http('hr.duty.getDutyNewMultList', { isFuzzy: 0, qryType: 1, jobType: val })
          .then(res => {
            this.JobLoading = false
            if (res && res.length) {
              this.jobs = res.map(v => ({ label: v.jobType, value: v.jobType }))
            }
          })
          .catch(_ => {
            this.JobLoading = false
          })
      },
      selectionChange (val) {
        this.selectedRows = val || []
      },
      async addRows () {
        let { dept, duty, isLeaf, jobs } = this.form
        if ((!dept || !dept.length) && !duty.length && !jobs.length) {
          this.$message.warning('请选择“组织”或者“岗位”或者“工种”')
          return
        }
        let data = {
          // departmentIds: dept || [],
          departmentId: dept[0] || '',
          dutyIds: duty,
          jobTypes: jobs,
          subsidiaryDepartment: isLeaf ? 'Y' : null
        }
        this.loading = true
        try {
          let arr = await this.$http('hr.remoteEmployee.listNonSensitive', data, { appkey: 55844 })
          this.handleBatchAdd(arr)
          this.form.duty = []
          this.clearDept()
        } finally {
          this.loading = false
        }
      },
      async deleteRows () {
        if (!this.selectedRows.length) {
          this.$message.warning('请勾选待删除行')
          return
        }
        await this.$confirm('您确定删除所选的数据吗？', '提示')
        let ids = this.selectedRows.map(v => v.id)
        this.rows = this.rows.filter(v => !ids.includes(v.id))
      },
      handleBatchAdd (arr, isImport) {
        let ids = this.rows.map(v => v.id)
        arr = arr.filter(v => !ids.includes(v.id) && this.$store.state.user.id !== v.id)
        arr = arr.map(item => this.formatUser(item, isImport))
        if (arr.length) {
          this.rows.splice(0, 0, ...arr)
          this.selectAppendRows(arr, false)
        }
        this.scrollTop()
        !isImport && this.$message.success(`添加${arr.length}条`)
      },
      formatUser (v, isImport) {
        return {
          id: v.id,
          employeeNumber: v.employeeNumber,
          chineseName: v.name,
          duty: v.duty,
          jobType: isImport ? v.jobType : v.dutyInfo.jobType,
          departmentName: v.department
        }
      },
      filterTemplate (val, cb) {
        if (!val || val.length < 2 || !this.templates) {
          cb(EMPTY_LIST)
          return
        }
        let arr = this.templates.filter(v => v.name && v.name.includes(val))
        cb(arr)
        // 自动选择第一行
        this.$nextTick(_ => {
          arr.length && this.$refs['templateFilter'].highlight && this.$refs['templateFilter'].highlight(0)
        })
      },
      // 搜索查询选择联动勾选
      selectTemplate (val) {
        if (val && !this.templateIds.includes(val.id)) {
          this.templateKey = ''
          this.$refs.shareTree.setChecked(val.id, true, true)
        }
      },
      scrollTop () {
        if (!this.tableBody) {
          this.tableBody = this.$el.querySelector('.el-table__body-wrapper')
        }
        if (this.tableBody) {
          this.tableBody.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },
      selectAppendRows (rows) {
        this.$nextTick(_ => {
          let fun = this.$refs.table.toggleRowSelection
          rows.forEach(row => fun(row, true))
        })
      },
      onTemplateChange (obj, checked) {
        if (checked) {
          if (obj && obj.name.length > 20) {
            this.$message.closeAll()
            this.$message.warning('要分享的标题不能超过20个字。备注：分享给其他人要简单明了')
            this.$refs.shareTree.setChecked(obj.id, false, true)
          } else {
            this.templateIds.push(obj.id)
          }
        } else {
          let id = obj.id
          let index = this.templateIds.findIndex(v => v === id)
          if (index !== -1) {
            this.templateIds.splice(index, 1)
          }
        }
      },
      showNameDialog (obj) {
        if (this.$refs.nameDialog) {
          this.curTemplate = obj
          this.formName.templateName = obj.name
          this.$refs.nameDialog.show = true
        }
      },
      getSaveTemplateParams () {
        // 通用查询
        const name = this.formName.templateName
        if (this.businessType === '0') {
          const { genericId, id, folderFlag } = this.curTemplate
          return { name, genericId, id, folderFlag }
        }
        // 个性化分享
        if (this.businessType === '1') {
          const { batchId } = this.curTemplate
          return { batchId, templateName: name }
        }
      },
      handleImport () {
         this.importConfig.show = true
      },
      importChange (data) {
        this.importConfig.importId = data
      },
      async importSuccess (data) {
        try {
          const { code, appkey, importId } = this.importConfig
          const params = {
            bizCode: code,
            bizId: importId
          }
          let arr = await this.$http('system.genericSearch.template.importSharePreview', params, { appkey })
          this.handleBatchAdd(arr, true)
        } finally {
          this.loading = false
        }
      },
      async saveTemplateName () {
        const params = this.getSaveTemplateParams()
        await this.$http(this.updateTemplateNameUrl, params)
        this.curTemplate.name = this.formName.templateName
        this.$message.success('模板名称保存成功')
        this.$emit('updateTemplateName', params)
      },
      changeDept (data) {
        this.form.isLeaf = data.leaf
      }
    }
  }
</script>

<style lang="scss">
  .kye-custom-filter-share > .el-dialog__body {
      display: flex;
      height: calc(70vh - 45px);
      padding: 0;
    }
  .kye-custom-filter-share {
    .tpl-wrap {
      width: 172px;
      display: flex;
      flex-direction: column;
      padding: 8px 0 8px 8px;
      border-right: 1px solid #dcdbe2;
      .el-tree-node__expand-icon {
        display: none;
      }
      .tpl-popper {
        padding-right: 8px;
        padding-bottom: 8px;
        .el-input__inner {
          padding-left: 24px !important;
          padding-right: 6px !important;
          border-radius: 14px;
          color: #333333;
          border-color: #dbdae6;
          background-color: #ffffff;
        }
        .el-input__prefix {
          top: 5px;
          padding-left: 4px;
          font-size: 14px;
          color: #b3b1b1;
        }
      }
      .tpl-list {
        overflow-x: hidden;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .tpl-name {
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100px;
        }
        .tpl-edit {
          width: 18px;
          height: 15px;
          margin-right: 4px;
          vertical-align: bottom;
        }
        .el-checkbox {
          display: block;
        }
        .el-checkbox + .el-checkbox {
          margin-left: 0 !important;
        }
        .el-checkbox__input {
          line-height: 1.8;
          vertical-align: baseline;
        }
        .el-checkbox__label {
          line-height: 16px;
          width: 140px;
        }
      }
      .el-scrollbar {
        flex: 1;
      }
      .el-scrollbar__wrap {
        height: 100%;
        overflow: auto;
        margin-right:0 !important;
      }
      .el-scrollbar__bar.is-horizontal {
        display: none;
      }
    }
    .user-wrap {
      flex: 1;
      padding: 12px;
      overflow: hidden;
      .kye-select--multiple {
        width: 160px;
        &.el-select .el-select__tags > span + .el-select__input {
          max-width: 40px !important;
          width: 40px !important;
        }
        .el-select__tags {
          max-width: 155px!important;
          .el-tag {
            max-width: 68px!important;
            display: inline-flex;
            align-items: center;
          }
          .el-select__input {
            width: auto !important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/template-share-dialog.vue